import { FC, useState } from 'react'

import { Input, InputProps } from '@UI/crypto_exchange/desktop/components/controls/Input'
import { ButtonControl } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/components/ButtonControl/ButtonControl'

import s from './styles.module.scss'

type InputWithButtonControlProps = {
  clearInput: () => void
  hideInputControl?: boolean
}

export const InputWithButtonControl: FC<InputProps & InputWithButtonControlProps> = ({
  clearInput,
  hideInputControl = false,
  ...props
}) => {
  const [showInput, setShowInput] = useState(false)

  const toggleInput = () => {
    clearInput()
    setShowInput((prev) => !prev)
  }

  return (
    <div className={s.wrapper}>
      {(showInput || hideInputControl) && <Input {...props} value={props.value ?? ''} />}

      {!hideInputControl && <ButtonControl onClick={toggleInput}>{showInput ? 'Hide note' : 'Add note'}</ButtonControl>}
    </div>
  )
}
